import { useToggle } from "@vueuse/core";
import {
  onScopeDispose,
  shallowRef,
  watch,
  type ShallowRef,
  type Ref,
} from "vue";
import type { EmojiCategory, EmojiCategoryKey } from "./emojiData";

export type { EmojiCategoryKey, EmojiCategory };

export interface UseEmojiReturn {
  categories: ShallowRef<EmojiCategory[]>;
  isOpen: Ref<boolean>;
  toggle: () => void;
  close: () => void;
}

export function useEmoji(): UseEmojiReturn {
  const [isOpen, toggleValue] = useToggle(false);
  const categories = shallowRef<EmojiCategory[]>([]);

  let disposed = false;
  onScopeDispose(() => {
    disposed = true;
  });

  // Lazy-load emoji data on first open
  watch(isOpen, async (open) => {
    if (open && categories.value.length === 0) {
      const { emojiCategories } = await import("./emojiData");
      if (disposed) return;
      categories.value = emojiCategories;
    }
  });

  function toggle(): void {
    toggleValue();
  }

  function close(): void {
    isOpen.value = false;
  }

  return {
    categories,
    isOpen,
    toggle,
    close,
  };
}
